import axios, {AxiosResponse} from "axios";
import {UserLocation} from "@/shared/services/UserLocation";
import {OfferInterface} from "@/shared/interfaces/OfferInterface";

type ResponseType = {
    offerMap: OfferInterface
}

const LOCAL_STORAGE_ITEM = 'efs-offer-location';
const LOCAL_STORAGE_ITEM_NAME = 'efs-offer-location-name';

export class OfferService {
    public async getOffer(contentId: string, selectedLocationId: string): Promise<OfferInterface> {
        const userLocation = selectedLocationId ? selectedLocationId : UserLocation.get();
        const result:AxiosResponse<ResponseType> = await axios
            .get(`/.rest/personalized/v1/offer/${contentId}/${userLocation}?desktop=width1440&desktop=width1024&desktop=width768&desktop=width640`,{
            headers: {
                'Cache-Control': 'max-age=60',
            }
        });

        return result.data.offerMap;
    }


    public static hasOfferLocation(): boolean {
        return !!localStorage.getItem(LOCAL_STORAGE_ITEM);
    }

    public static getOfferLocation(): string | null {
        if (!this.hasOfferLocation()) return null;
        return localStorage.getItem(LOCAL_STORAGE_ITEM);
    }

    public static setOfferLocation(identifier: string, city: string) {
        localStorage.setItem(LOCAL_STORAGE_ITEM, identifier);
        localStorage.setItem(LOCAL_STORAGE_ITEM_NAME, city);
        console.log("dispatch offer location changed");
        window.dispatchEvent(
            new Event('OfferMarketChanged')
        );
    }

    public static removeOfferLocation() {
        localStorage.removeItem(LOCAL_STORAGE_ITEM);
        localStorage.removeItem(LOCAL_STORAGE_ITEM_NAME);

        window.dispatchEvent(
            new Event('OfferMarketChanged')
        );
    }
}
